import routes, { RouteName } from '@config/routes';
import { forEach } from 'lodash';
import history from './history';
import qs from 'qs';

export const getPath = (
  routeName: RouteName,
  params?: Record<string, any>,
  queryParams?: Record<string, any>,
) => {
  const currentRoute = routes[routeName];
  let path = currentRoute.path;

  let queryString = '';
  if (queryParams) {
    queryString = qs.stringify(queryParams, { addQueryPrefix: true });
  }

  if (currentRoute.getPath && params) {
    return currentRoute.getPath(params);
  } else if (params) {
    forEach(params, (paramValue: string, paramKey: string) => {
      path = path.replace(`:${paramKey}`, paramValue);
    });
    return path + queryString;
  }

  return currentRoute.path + queryString;
};

export const formatPostUrl = (postUrl: string): string => {
  try {
    const formattedPostUrl = new URL(postUrl);
    const postId = formattedPostUrl.searchParams.get('id');

    if (!postId) {
      return postUrl;
    }

    formattedPostUrl.pathname = `${formattedPostUrl.pathname.replace(/\/$/, '')}/${encodeURIComponent(
      postId,
    )}`;
    formattedPostUrl.search = '';

    return formattedPostUrl.toString();
  } catch (e) {
    return postUrl;
  }
};

export const goTo = (
  routeName: RouteName,
  params?: Record<string, any>,
  queryParams?: Record<string, any>,
) => {
  history.push(getPath(routeName, params, queryParams));
};

export const changeParams = (params: Record<string, any> | null, state?: unknown) => {
  const oldParams = getQuery();
  const newParams = { ...oldParams, ...params };
  history.replace(
    {
      pathname: history.location.pathname,
      search: `?${qs.stringify(newParams)}`,
    },
    state,
  );
};

export const getQuery = () => {
  return qs.parse(history.location.search, {
    ignoreQueryPrefix: true,
  });
};
